const numberPattern = /[-]{0,1}[\d]*[.]{0,1}[\d]+/g;

export const parsePrice = (value) => {
  const matches = value && String(value).match(numberPattern);

  return matches ? parseFloat(matches.join('')) : '';
};

export const hasPrice = (value) => parsePrice(value) > 0;
